import request from '@/utils/request'
import store from '@/store'
//送审
export function documentToaudit(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/toaudit',
        method: 'post',
        data,
    })
}

//文档审核
export function documentAudit(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/audit',
        method: 'post',
        data,
    })
}

//文档审核列表
export function documentAuditList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/auditlist',
        method: 'post',
        data,
    })
}

//文档预览
export function documentView(data) {
     let div = top.document.createElement("div");
     div.id = "placeholder"
    // top.document.body.appendChild(div)
    let newwindow=window.open();
    
    let documentType ='text';
    switch (data.FileExt) {  
        case '.doc':
        case '.docx':
        case '.htm':
        case '.txt':
        case '.xps':
        case '.pdf':
        case '.dot':
            documentType = 'text';
            break;
        case '.csv':
        case '.xls':
        case '.xlsx':
        case '.xltx':
        case '.xlt':
            documentType = 'spreadsheet';
            break;
        case '.ppt':
        case '.pptx':
            documentType = 'presentation';
        default:

    }
    let timestamp = Date.parse(new Date(data.DocUpdateTime?data.DocUpdateTime:data.UpdateTime));
    timestamp = timestamp / 1000
    let config = {
        "document": {
            "fileType": data.FileExt.split('.')[1],
            "key": data.id+timestamp,
             "title": data.Name,
             "url": process.env.VUE_APP_System_Api+"/api/document/download?id="+(data.id?data.id:data.ID)+"&isdownload="+data.isdownload+"&isattach="+data.isattach+"&usertoken="+store.getters.token,
        //    "fileType":"docx",
        //    "title":"示例文档Title.docx",
        //     "key":"Khirz6zTPdfd7",
        //     "url":"https://example.com/url -to-example-document.docx",
            
            "permissions": {
                "changeHistory": false,
                "comment": false,
                "download": false,
                "edit": false,
                "fillForms": true,
                "modifyContentControl": false,
                "modifyFilter": false,
                "print": true,
                "review": true
            },
        },
        "documentType": documentType,
        //"documentType": "text",
        'editorConfig': {
            'mode': 'view',
            'lang': 'zh',
            'customization': {
                'chat': false,
                'comments': false,
                'help': false,
                "compactHeader": true,
                "compactToolbar": true
            }
        }
    }
    
    
    newwindow.document.write(`<div id="placeholder"></div><script src="${process.env.VUE_APP_DOCUMENT_SERVER_URL}web-apps/apps/api/documents/api.js""></script><script>new DocsAPI.DocEditor("placeholder",${JSON.stringify(config)});</script>`)

    request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/preview',
        method: 'get',
        params:{docid:data.ID}
    })
}

//文档下载
export function documentDownload(data,type) {
    if(type){
        request({
            baseURL: process.env.VUE_APP_System_Api,
            url: '/api/document/preview',
            method: 'get',
            params:{docid:data.id?data.id:data.ID}
        })
        data.isdownload =0
        let img = document.createElement('img')
        let newwindow=window.open();
        newwindow.document.write(`<img src=${process.env.VUE_APP_System_Api+"/api/document/download?id="+(data.id?data.id:data.ID)+"&isdownload="+data.isdownload+"&isattach="+data.isattach+"&usertoken="+store.getters.token}>`);
    }else{
        let a = document.createElement('a')
        a.href =process.env.VUE_APP_System_Api+"/api/document/download?id="+(data.id?data.id:data.ID)+"&isdownload="+data.isdownload+"&isattach="+data.isattach+"&usertoken="+store.getters.token
        top.document.body.appendChild(a)
        a.click();
        top.document.body.removeChild(a);
    }
    // return request({
    //     baseURL: process.env.VUE_APP_System_Api,
    //     url: '/api/document/download',
    //     method: 'get',
    //     params: data,
    // })
}

//审核记录
export function documentAuditRecord(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/auditrecord',
        method: 'get',
        params: data
    })
}

//操作记录
export function documentOperations(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/operations',
        method: 'get',
        params: data
    })
}

//获取共享文件类表
export function documentAttachDelete(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/attach/delete',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

//获取我的共享文件类表
export function documentShareMineList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/share/minelist',
        method: 'get',
        params: data
    })
}

//获取共享给我文件类表
export function documentShareList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/share/list',
        method: 'get',
        params: data
    })
}

//删除共享
export function documentShareDelete(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/share/delete',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

//新增共享
export function documentShareAdd(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/share/add',
        method: 'post',
        data
    })
}

//获取文件夹树
export function documentFolderTree(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/folder/tree',
        method: 'get',
        params: data
    })
}

//添加文件夹
export function documentFolderAdd(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/folder/add',
        method: 'post',
        data
    })
}

//编辑文件夹
export function documentFolderEdit(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/folder/edit',
        method: 'post',
        data
    })
}

//删除文件夹
export function documentFolderDelete(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/folder/delete',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

//删除文件
export function documentDelete(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/delete',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

//编辑文件
export function documentEdit(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/edit',
        method: 'post',
        params:{
            id:data.ID,
            name:data.Name,
            folderid:data.ParentID
        }
    })
}

//获取第一层级文件列表（文档+文件夹）
export function documentFirstlevellist(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/firstlevellist',
        method: 'get',
        params: data
    })
}

//懒加载
export function documentFolderChildren(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/document/folder/children',
        method: 'get',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/document.js